import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';

export const isUnauthorized = (response: HttpErrorResponse): boolean => {
  return response.status === HttpStatusCode.Unauthorized;
};
